import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getDeviceDetails } from "../../store/service";
import { getFormattedDate } from "../../util/dateFormatting";
import i18nService from "../../util/Internationalization/i18n/i18n";
import { Notification } from "../common/Notification";

function MavDeviceDetails({ closeDialog, detail, date }: any) {
    const [showDevice, setShowDevice] = useState(true);
    const [loading, setLoading] = useState<boolean>(true);
    const [active, setActive] = useState<any>("");
    const [data, setData] = useState<any>([]);
    const { t: tLang } = useTranslation();
    useEffect(() => {
        if (detail) {
            setLoading(true);
            getDeviceDetails({
                deviceId: detail.deviceId,
                childEzshieldID: detail.ezShieldID,
                startDate: moment(date.startDate).format("YYYY-MM-DD"),
                endDate: moment(date.endDate).format("YYYY-MM-DD"),
            })
                .then((res) => {
                    setLoading(false);
                    if (res.isSuccess) {
                        setData(res.scanData);
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    Notification({
                        type: "error",
                        title: "Error",
                        message: err,
                        duration: 5,
                    });
                });
        }
    }, [detail, date]);

    const getField = (field: string, value: any) => {
        return (
            <div className="data-grid has-lines row-height-m mav-device-detail pl-s">
                <div className="data-row row flex-center padding-vertical-xs">
                    <div className="col-xs-12 col-sm-4 col-no-gutter">
                        <span className="label">{field}</span>
                    </div>
                    <div className="col-xs-12 col-sm-8 col-no-gutter">
                        <span className="desc">{value}</span>
                    </div>
                </div>
            </div>
        );
    };
    const getScanField = (field: string, value: any, isRisk: boolean) => {
        return (
            <div className="row padding-vertical-xs mav-device-detail">
                <div className="col-xs-4 col-sm-4 col-no-gutter">
                    <span className="label">{field}</span>
                </div>
                <div className="col-xs-8 col-sm-8 col-no-gutter">
                    <span className={isRisk ? "desc error" : "desc success"}>{value}</span>
                </div>
            </div>
        );
    };
    return (
        <div>
            <div className="dialog-header mav-device-detail">
                <div className="dialog-icon status-blue">
                    <em className="las la-mobile"></em>
                </div>
                {detail && <h1 className="fs-18">{detail.deviceName}</h1>}
                <p className="heading-info">
                    We found {detail.risks} {Number(detail.risks) <= 1 ? " risk" : " risks"} on device ID {detail.deviceId} {detail.deviceName}.{" "}
                </p>
                {detail && <div className="alert-date">Scan on {getFormattedDate(i18nService.get("Country"), detail.lastScan)}</div>}
            </div>
            <div className="dialog-body">
                <div className="data-row row">
                    <div className="col-xs-12 pl-0">
                        <div className="display-flex" onClick={() => setShowDevice(!showDevice)}>
                            <span>
                                <em
                                    className="las la-caret-up"
                                    style={{
                                        transform: showDevice ? "rotate(180deg)" : "rotate(90deg)",
                                    }}
                                ></em>
                            </span>

                            <span className="collapse-title-text f-14 device-label">{showDevice ? "Hide device details" : "Show device details"}</span>
                        </div>
                    </div>
                </div>
                {detail && showDevice && (
                    <>
                        {detail.deviceName && getField("Device Name", detail.deviceName)}
                        {detail.deviceId && getField("Device ID", detail.deviceId)}
                        {detail.firstName && getField("Device User", `${detail.firstName} ${detail.lastName}`)}
                        {detail.lastScan && getField("Last Scan", moment(detail.lastScan).format("MM/DD/YY , LT"))}
                        {detail && getField("Risks Found", detail.risks)}
                    </>
                )}
            </div>
            <div className="row">
                <div className="col-xs-12 pl-0">
                    <div className="dialog-header mav-device-detail pt-1">
                        <h1 className="fs-18">Recent Scans</h1>
                    </div>
                </div>
            </div>
            <div className={loading ? "row  mav-device-detail loading" : "row  mav-device-detail"}>
                <div className="col-xs-4 col-sm-4">
                    <span className="label">Scan date</span>
                </div>
                <div className="col-xs-1 col-sm-4"></div>
                <div className="col-xs-4 col-sm-3">
                    <span className="label">IP address</span>
                </div>
                <div className="col-xs-2 col-sm-1">
                    <span className="label">Risks</span>
                </div>
            </div>

            {data.length > 0 &&
                data.map((item: any) => {
                    return (
                        <>
                            <div
                                className="data-row"
                                onClick={() => {
                                    if (active === item.id) {
                                        setActive("");
                                    } else {
                                        setActive(item.id);
                                    }
                                }}
                            >
                                <div className="data-grid has-lines row-height-m mav-device-detail pointer">
                                    <div className="data-row row flex-center">
                                        <div className="col-xs-4 col-sm-4 pl-0">
                                            <div className="display-flex">
                                                <span>
                                                    <em
                                                        className="las la-caret-up"
                                                        style={{
                                                            transform: active === item.id ? "rotate(180deg)" : "rotate(90deg)",
                                                        }}
                                                    ></em>
                                                </span>

                                                <span className="collapse-title-text desc">{moment(item.date).format("MM/DD/YY , LT")}</span>
                                            </div>
                                        </div>
                                        <div className="col-xs-1 col-sm-4"></div>
                                        <div className="col-xs-4 col-sm-3">
                                            <span className="desc">{item.ipAddress}</span>
                                        </div>
                                        <div className="col-xs-2 col-sm-1">
                                            <span className="desc">{item.risksFound}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {active === item.id
                                ? item.risks.map((risk: any, i: number) => {
                                      return <div key={i}>{getScanField(risk.type, risk.value, risk.isRisk)}</div>;
                                  })
                                : null}
                        </>
                    );
                })}

            <div className="dialog-footer">
                <div className="row between-xs">
                    <div className="col-xs-12 col-no-gutter flex-grow-null flex-end">
                        <button type="button" className="btn-default btn-primary" onClick={closeDialog}>
                            <span className="btn-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.Close")}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MavDeviceDetails;
